<template>
  <div id="customize-field" class="">
    <div v-for="options in fields"  v-bind:class="col != null ? 'col-' + col : 'full-width'" v-if="fields.length > 0">
      <b-form-group v-if="checkConfigStore($auth.user(), 'hide-new-order-tracker', option)" v-for="(option, index) in options.body" v-bind:label="$t((prefix != '' ? prefix + '.' : '') + options.title)" :label-cols="label_cols" :horizontal="horizontal">
        <div :role="options.body.length > 1 ? 'group' : ''" :class="options.body.length > 1 ? 'input-group' : ''">
          <template>
            <b-form-input :type="input_type" :key="option.id" :class="option.options.class" v-model="value[option.name]" :readonly="option.options.readonly" v-if="option.input_type == 'input' && input_type != 'number'" v-on:input="submit">
            </b-form-input>
            <b-form-input :type="input_type" :onkeyup="onkeyup" :readonly="option.options.readonly" v-model="value[option.name]" v-if="option.input_type == 'input' && input_type == 'number'" v-on:input="submit">
            </b-form-input>

            <textarea
              :class="option.options.class + 'form-control form-control'"
              v-model="value[option.name]"
              :readonly="option.options.readonly"
              :rows="option.options.rows"
              :max-rows="option.options.max_rows"
              @input="submit"
              v-if="option.input_type == 'textarea'">
            </textarea>

            <c-switch
              type="icon" variant="success"
              v-bind="{on: '\uf00c', off: '\uf00d'}"
              v-model="value[option.name]"
              :pill="true"
              :checked="option.options.default"
              :value="option.options.value"
              :uncheckedValue="option.options.unchecked_value"
              @change="updateValue"
              v-if="option.input_type == 'switch'"/>

            <masked-input
              type="text"
              name="date"
              :class="option.options.class + ' ' + option.name"
              v-model="value[option.name]"
              :mask="[/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
              :guide="true"
              placeholderChar="_"
              :showMask="true"
              :keepCharPositions="true"
              v-if="option.input_type == 'masked-input'"
              @input="submit"
              :readonly="option.options.readonly">
            </masked-input>

            <div class="input-group-append" v-if="index < (options.body.length - 1)">
              <div class="input-group-text"><i class="fa fa-minus"></i></div>
            </div>
          </template>
        </div>
      </b-form-group>
    </div>
  </div>
</template>
<style scoped>
  .col-1, .col-2, .col-3, .col-4, .col-5, .col-6, .col-7, .col-8, .col-9, .col-10, .col-11, .col-12, .col, .col-auto, .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm, .col-sm-auto, .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12, .col-md, .col-md-auto, .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg, .col-lg-auto, .col-xl-1, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl, .col-xl-auto {
    float: left;
  }
</style>
<script>
  import cSwitch from '../../components/Switch'
  import vSelect from 'vue-select'
  import MaskedInput from 'vue-text-mask'

  export default {
    name: 'CustomizeField',
    components: {
      cSwitch,
      vSelect,
      MaskedInput
    },
    props: {
      onkeyup: {
        required: false,
        default: ""
      },
      input_type: {
        required: false,
        default: 'text'
      },
      label_cols: {
        required: false,
        default: '2'
      },
      horizontal: {
        type: Boolean,
        required: false,
        default: true
      },
      position: {
        required: true
      },
      element: {
        required: true
      },
      type: {
        type: String,
        required: true
      },
      item: {
        required: true
      },
      col: {
        required: false
      },
      update: {
        required: false
      },
      prefix: {
        type: String,
        required: false,
        default: ''
      }
    },
    data: function () {
      return {
        fill: false,
        value: {},
        fields: {}
      }
    },
    methods: {
      checkConfigStore (user, value, option) {
        const arrs = ['is_new_order_confirmation'];
        const dataModules = user && user.modules
        let checkModules = []
        if (dataModules.length > 0) {
          checkModules = dataModules.filter((item) => item === value)
        }
        const checkCustomize = arrs.includes(option && option.name)
        if (checkModules.length === 0 && checkCustomize) {
          return false
        }
        return true
      },
      updateValue: function (val) {
        this.updateItem()
        this.$emit('input', this.value)
      },
      submit: function () {
        this.updateItem()
        this.$emit('input', this.value)
      },
      updateItem: function () {
        for (let i = 0; i < this.fields.length; i++) {
          console.log(this.fields[i])
        }
        for (let i in this.value) {
          this.item[i] = this.value[i]
        }
      },
      render: function () {
        let fields = []//this.$auth.user().config[this.type].fields
        if (this.$store.getters.config.gms[this.type] != null && this.$store.getters.config.gms[this.type].fields != null) {
          fields = this.$store.getters.config.gms[this.type].fields
        }
        this.fields = []
        this.value = null
        let val = []
        for (let i = 0; i < fields.length; i++) {
          let field = fields[i]
          if (field.position != null) {
            if (field.position.field == this.element) {
              let flag = false
              if (this.position == 'before') {
                if (field.position.before) {
                  flag = true
                }
              } else if (this.position == 'after') {
                if (field.position.after) {
                  flag = true
                }
              }

              if (flag) {
                for (let j in field.body) {
                  if (typeof this.item[field.body[j].name] == 'undefined') {
                    this.item[field.body[j].name] = field.body[j].options.default
                  }
                  val[field.body[j].name] = this.item[field.body[j].name]
                }
                this.fields.push(field)
              }
            }
          }
        }
        this.value = val
        this.fill = false
      }
    },
    created: function () {
      this.render()
    },
    watch: {
      update: function () {
        this.fill = this.update
        if (this.fill == true) {
          this.render()
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Partials/CustomizeField.vue